<div class="py-3 bg-primary text-light custom-padding-bottom">
  <div class="container">
    <digital-platform-dynamic-content-wrapper
      [config]="nestedContentContainers[0]"
    ></digital-platform-dynamic-content-wrapper>
  </div>
</div>

<digital-platform-dynamic-content-wrapper
  [config]="nestedContentContainers[1]"
></digital-platform-dynamic-content-wrapper>
